import { ReactNode } from 'react';

import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import {
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import { DE_DIRECT_BASE_PATHNAME, UK_DIRECT_BASE_PATHNAME } from '../constants';

type TProps = {
  children: ReactNode;
};

export const DynamicBrowserRouter = ({ children }: TProps) => {
  const isDirectCustomer =
    window.location.pathname.includes(`/${UK_DIRECT_BASE_PATHNAME}`) ||
    window.location.pathname.includes(`/${DE_DIRECT_BASE_PATHNAME}`);

  const router = createBrowserRouter(
    createRoutesFromElements(<Route path="/*" element={children} />),
    { basename: `/${isDirectCustomer ? '' : 'partner-signup'}` },
  );

  return <RouterProvider router={router} />;
};
